import { render } from "./UrgentBanner.vue?vue&type=template&id=0cf323eb&scoped=true"
import script from "./UrgentBanner.vue?vue&type=script&lang=js"
export * from "./UrgentBanner.vue?vue&type=script&lang=js"

import "./UrgentBanner.vue?vue&type=style&index=0&id=0cf323eb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf323eb"]])

export default __exports__